function MenuTheme({ card }) {
  // console.log(card);


  const handleButtonClick = () => {
    if (card?.data?.buttonLink && card?.data?.buttonLink !== "#") {
      window.open(card?.data?.buttonLink, "_blank");
    }
  };

  return (
    <div className="flex p-2 md:py-4 justify-center min-h-screen bg-gray-400">
      <div className={`relative max-w-[393px] overflow-hidden ${card?.data?.showBackgroundImage ? "bg-black" : "bg-[#222222]"} rounded-xl shadow-lg font-poppins`}>
        {/* Cover Image */}
        {card?.backgroundImage && card?.data?.showBackgroundImage && (
          <div className="relative">
            <img
              src={card?.backgroundImage}
              alt="Background"
              className="w-full h-80 object-cover"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40 pointer-events-none"></div>
          </div>
        )}

        {/* Title */}
        <div
          className={
            card?.data?.showBackgroundImage
              ? "absolute top-[7rem] left-1/2 transform -translate-x-1/2 text-center w-full"
              : "pt-6 flex justify-center items-center text-center w-full"
          }
        >
          <h2 className="text-3xl font-bold text-white break-all break-words">{card?.data?.title}</h2>
        </div>

        <div className="bg-[#222222] px-2 py-3">
          <div>
            <p className="text-[#D0D0D0] text-center break-all break-words">
              {card?.data?.description}
            </p>
          </div>
          {/* <div className="flex justify-center items-center py-5 ">
            <button className="btn btn-active border-none px-6 py-2 rounded-xl bg-white text-[#82066E]">
              {fallbackData.buttonLabel}
            </button>
          </div> */}
          {/* Button */}
          <div className="flex justify-center items-center py-5">
            <button
              className="btn btn-active border-none px-6 py-2 rounded-xl bg-white text-[#82066E] break-all break-words"
              onClick={handleButtonClick}
            >
              {card?.data?.buttonLabel}
            </button>
          </div>
          {/* Gallery Images */}
          <div className="grid grid-cols-1 gap-2 py-2 px-4">
            {card?.data?.galleryImages?.map((image, index) => (
              <div key={index} className="rounded-md overflow-hidden">
                <img
                  src={image}
                  alt={`Gallery ${index + 1}`}
                  className="w-full h-auto"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MenuTheme;



